import React, { useState, useEffect } from 'react';
import { MindmapNode } from '../../services/mindmapService';
import './Mindmap.css';

interface MindmapNodeModalProps {
  node: MindmapNode | null;
  onSave: (label: string, color: string, size: number) => void;
  onClose: () => void;
}

const MindmapNodeModal: React.FC<MindmapNodeModalProps> = ({ node, onSave, onClose }) => {
  const [label, setLabel] = useState('');
  const [color, setColor] = useState('#ffffff');
  const [size, setSize] = useState('20');

  useEffect(() => {
    if (node) {
      setLabel(node.label);
      setColor(node.color || '#ffffff');
      setSize(node.size.toString());
    } else {
      setLabel('');
      setColor('#ffffff');
      setSize('20');
    }
  }, [node]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!label.trim()) return;

    onSave(label.trim(), color, parseInt(size) || 20);
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="mindmap-modal-backdrop" onClick={handleBackdropClick}>
      <div className="mindmap-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mindmap-modal-header">
          <h3 className="mindmap-modal-title">
            {node ? 'Edit Node' : 'Create Node'}
          </h3>
          <button className="mindmap-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit} className="mindmap-modal-form">
          <div className="mindmap-modal-field">
            <label className="mindmap-modal-label">Label</label>
            <input
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              className="mindmap-modal-input"
              placeholder="Enter node label..."
              autoFocus
              required
            />
          </div>
          <div className="mindmap-modal-field">
            <label className="mindmap-modal-label">Color</label>
            <div className="mindmap-color-input-wrapper">
              <input
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                className="mindmap-color-input"
              />
              <input
                type="text"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                className="mindmap-color-text-input"
                placeholder="#ffffff"
              />
            </div>
          </div>
          <div className="mindmap-modal-field">
            <label className="mindmap-modal-label">Size</label>
            <input
              type="number"
              value={size}
              onChange={(e) => setSize(e.target.value)}
              className="mindmap-modal-input"
              min="10"
              max="50"
              required
            />
          </div>
          <div className="mindmap-modal-actions">
            <button type="submit" className="mindmap-modal-save-btn">
              {node ? 'Update' : 'Create'}
            </button>
            <button type="button" onClick={onClose} className="mindmap-modal-cancel-btn">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MindmapNodeModal;

